import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';

const EmailThreadCounter = ({ remainingCount, onLoadMore }) => {
  return (
    <div className="tw-relative tw-flex tw-items-center tw-p-0 tw-mb-[10px] tw-border-y tw-border-cfo-grey-400">
      <Button
        onClick={onLoadMore}
        className={clsx(
          'tw-absolute tw-left-[50%] tw-right-[50%] tw-z-[2] tw-w-fit',
          'tw-rounded-[50px] ',
          'tw-m-0 tw-px-[18px] tw-py-[4px]',
          'hover:tw-bg-cfo-blue-600 hover:tw-text-white',
          'tw-shadow-[1px_2px_4px_0px_rgba(80,129,255,0.2)]'
        )}
        buttonClassSettings={{
          variant: 'primary_light_blue',
          size: 'md',
          weight: 'bold',
          position: 'center',
        }}
      >
        <span>{remainingCount}</span>
      </Button>
    </div>
  );
};

export default EmailThreadCounter;
